export default __webpack_public_path__ + "images/K1.27b6cba.png";